import { required } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { NumberInput } from "@/components/admin/number-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";

import { prospectStages } from "../prospects/prospectModel";
import { automationActionTypes } from "./automationModel";

export const AutomationRuleInputs = () => (
  <div className="flex flex-col gap-4">
    <TextInput
      source="name"
      label="Rule name"
      validate={required()}
      helperText="e.g. 'Mail intro postcard when contacted'"
    />
    <SelectInput
      source="to_stage"
      label="When a prospect enters stage"
      choices={prospectStages}
      validate={required()}
      helperText={false}
    />
    <SelectInput
      source="action_type"
      label="Do this"
      choices={automationActionTypes}
      validate={required()}
      helperText={false}
    />
    <NumberInput
      source="action_config.designID"
      label="PostcardMania design ID"
      validate={required()}
      helperText="Find design IDs in the PostcardMania portal (or the pcm list_designs tool)"
    />
    <SelectInput
      source="action_config.mailClass"
      label="Mail class"
      choices={[
        { id: "FirstClass", name: "First Class (faster, ~3-5 days)" },
        { id: "Standard", name: "Standard (cheaper, ~1-2 weeks)" },
      ]}
      helperText="Defaults to First Class when unset"
    />
    {/* Mail actions spend money, so approval is not optional — the DB enforces
        it (automation_rules_money_needs_approval) and the trigger enqueues
        money jobs as pending_approval regardless. */}
    <p className="text-sm text-muted-foreground">
      Triggered mail waits in the Outbox until you approve it — orders are
      never placed automatically.
    </p>
    <BooleanInput source="enabled" label="Enabled" helperText={false} />
  </div>
);
